import type { Campaign } from './campaignsApi';

export function campaignPlatformLabel(campaign: Campaign) {
  const meta = Boolean(campaign.meta_campaign_id || campaign.meta_ad_account_id);
  const google = Boolean(campaign.google_campaign_id || campaign.google_customer_id
    || ['google', 'google_ads'].includes(campaign.ad_platform || ''));
  return meta && google ? 'Meta Ads e Google Ads' : google ? 'Google Ads' : meta ? 'Meta Ads' : 'Cadastro local';
}

export function campaignOriginDetails(campaign: Campaign) {
  const details = [];
  const meta = Boolean(campaign.meta_campaign_id || campaign.meta_ad_account_id || campaign.meta_adset_id || campaign.meta_ad_id);
  const google = Boolean(campaign.google_campaign_id || campaign.google_customer_id || ['google', 'google_ads'].includes(campaign.ad_platform || ''));
  if (meta) details.push({ provider: 'Meta Ads', campaignId: campaign.meta_campaign_id,
    accountId: campaign.meta_ad_account_id,
    message: campaign.meta_campaign_id ? 'Campanha vinculada' : 'Conta definida, sem campanha externa' });
  if (google) details.push({ provider: 'Google Ads', campaignId: campaign.google_campaign_id,
    accountId: campaign.google_customer_id,
    message: campaign.google_campaign_id ? 'Campanha vinculada' : 'Sem campanha externa vinculada' });
  if (!meta && !google) details.push({ provider: 'Cadastro local', campaignId: undefined,
    accountId: undefined, message: 'Sem vínculo com conta ou campanha externa' });
  return details;
}
